jQuery(document).ready(function ($) {
  // click on second level menu with children
  $(".dropdown-item.has-children").on("click", function (e) {
    e.preventDefault();

    const dropdown = $(this).closest(".menu__mega-outer");
    const target = $(this).data("target");

    // remove the default image from the parent menu item if it is present
    dropdown
      .find(".menu__third-level-rollover-image.active")
      .removeClass("active");

    // remove from existing third level menu
    dropdown.find(".third-level.active").removeClass("active");

    // remove from existing parent
    dropdown.find(".dropdown-item.active").removeClass("active");

    // add to this element
    $(this).addClass("active");

    // add to the menu
    dropdown.find(".third-level." + target).addClass("active");
  });

  $(".dropdown-item.has-rollover-image").on("mouseenter", function (e) {
    const dropdown = $(this).closest(".menu__mega-outer");
    const target = $(this).data("target");

    dropdown
      .find(".menu__third-level-rollover-image.active")
      .removeClass("active");

    dropdown
      .find(".menu__third-level-rollover-image." + target)
      .addClass("active");
  });

  $(".dropdown-item.has-rollover-image").on("mouseleave", function (e) {
    const dropdown = $(this).closest(".menu__mega-outer");
    const target = $(this).data("target");

    dropdown
      .find(".menu__third-level-rollover-image." + target)
      .removeClass("active");
  });

  // prevent click on href that is just anchor link
  // TODO: check this doesn't stop anything useful happening!
  $("a[href='#']").on("click", (e) => {
    e.preventDefault();
  });

  // TODO: is buggy, needs a fix!
  // listener for hover on top level menu item with children
  $(".top-level.menu-item-has-children").on("mouseenter", function () {
    $(".header__outer").addClass("mega-menu-active");
    document.body.classList.add("mega-menu-active");
    // logic for locking body scroll
    // const noScroll = "no-scroll";
    // const body = document.body;
    // if (!body.classList.contains(noScroll)) {
    //   body.classList.add(noScroll);
    // }
  });

  // listener for hover leave on top level menu item with children
  $(".top-level.menu-item-has-children").on("mouseleave", function () {
    $(".header__outer").removeClass("mega-menu-active");
    document.body.classList.remove("mega-menu-active");

    setTimeout(function () {
      $(".default-image.menu__third-level-rollover-image").addClass("active");
    }, 500);
    // logic for unlocking body scroll
    // const noScroll = "no-scroll";
    // const body = document.body;
    // if (body.classList.contains(noScroll)) {
    //   body.classList.remove(noScroll);
    // }
  });

  // if it is the home page, make sure that the content of the page is sat under the header
  if ($("body.home").length) {
    const header = document.querySelector("#masthead");

    if (header) {
      const headerHeight = header.clientHeight;
      const primaryContent = document.querySelector("#primary");
      const newPrimaryMarginTop = `-${headerHeight}px`;

      if (newPrimaryMarginTop !== primaryContent.style.marginTop) {
        primaryContent.style.marginTop = newPrimaryMarginTop;
      }
    }
  }

  // scope this to only happen on the home page - for making header white at top of home page
  const headerOuter = document.querySelector("body.home .header__outer");

  if (headerOuter) {
    headerOuter.addEventListener("mouseenter", function (e) {
      if (!this.classList.contains("active")) this.classList.add("active");
    });

    headerOuter.addEventListener("mouseleave", function (e) {
      if (this.classList.contains("active")) this.classList.remove("active");
    });
  }
});
